@if (showBreadcrumbs) {
  <ul class="breadcrumb-list">
    <li
      class="breadcrumb-item"
            [ngClass]="{
            active: currentURL === '/info',
            completed:
                status === 'tos_complete' ||
                status === 'driver_info_complete' ||
                status === 'profile_complete' ||
                status === 'payment_complete'
        }"
    >
        <a [routerLink]="['/info']" id="signup-info-link" routerLinkActive="router-link-active"
        >Driver Info</a
        >
      </li>
      <li
        class="breadcrumb-item"
            [ngClass]="{
            active: currentURL === '/profile',
            completed:
                status === 'driver_info_complete' ||
                status === 'profile_complete' ||
                status === 'payment_complete'
        }"
    >
        @if (
                !(
                    status === 'driver_info_complete' ||
                    status === 'profile_complete' ||
                    status === 'payment_complete'
                )
            ) {
            <a
            id="signup-profile-inactive-link"
        >Tablet Profile</a
        >
        }
        @if (
                status === 'driver_info_complete' ||
                status === 'profile_complete' ||
                status === 'payment_complete'
            ) {
            <a
            [routerLink]="['/profile']"
            id="signup-tablet-profile-active-link"
            routerLinkActive="router-link-active"
            >Tablet Profile</a
        >
        }
    </li>
    <li
            class="breadcrumb-item"
            [ngClass]="{
            active: currentURL === '/payment',
            completed:
                status === 'profile_complete' || status === 'payment_complete'
        }"
            >
            @if (
              !(
              status === 'profile_complete' ||
              status === 'payment_complete'
              )
              ) {
              <a
                id="signup-shipping-info-inactive-link"
                >Shipping Info</a
                >
              }
              @if (
                status === 'profile_complete' || status === 'payment_complete'
                ) {
                <a
                  [routerLink]="['/payment']"
                  routerLinkActive="router-link-active"
                  id="signup-shipping-info-active-link"
                  >Shipping Info</a
                  >
                }
              </li>
              @if (!enforceUberConnectFlag && (texted_logs !==  'uber_required_manual_logs_failed')) {
                <li
                  class="breadcrumb-item"
            [ngClass]="{
            active: currentURL === '/proof_of_rides',
            completed: status === 'payment_complete'
        }"
                  >
                  @if (!(status === 'payment_complete' && texted_logs !== 'uber_required_manual_logs_failed')) {
                    <a id="signup-proof-of-rides-inactive-link">Proof of rides</a>
                  }
                  @if (status === 'payment_complete' && texted_logs !== 'uber_required_manual_logs_failed') {
                    <a
                      [routerLink]="['/proof_of_rides']"
                      routerLinkActive="router-link-active"
                      id="signup-proof-of-rides-active-link"
                      >Proof of rides</a
                      >
                    }
                  </li>
                }
                @if (enforceUberConnectFlag && (isUberConnected$ | async) === false) {
                  <li
                    class="breadcrumb-item"
            [ngClass]="{
            active: currentURL === '/uber-connect-required',
            completed: status === 'payment_complete'
        }"
                    >
                    @if (!(status === 'payment_complete')) {
                      <a id="signup-uber-connect-active-link">
                        Uber Connect Required
                      </a>
                    }
                    @if (status === 'payment_complete') {
                      <a
                        [routerLink]="['/uber-connect-required']"
                        routerLinkActive="router-link-active"
                        id="signup-uber-connect-inactive-link"
                        >Uber Connect Required</a
                        >
                      }
                    </li>
                  }
                </ul>
              }
